export const FREE_SHIPPING_THRESHOLD_PLACEHOLDER = "fst";
